module.exports = __webpack_public_path__ + "img/timer_without_mins.64523e03.svg";